import React from 'react'
import withIconStyles from './HOC/withIconStyles'
import SVG from './common/SVG'

const IconClockFilled = (props) => (
  <SVG
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.99166 1.66666C5.39166 1.66666 1.66666 5.39999 1.66666 9.99999C1.66666 14.6 5.39166 18.3333 9.99166 18.3333C14.6 18.3333 18.3333 14.6 18.3333 9.99999C18.3333 5.39999 14.6 1.66666 9.99166 1.66666ZM12.7417 13.925L9.16666 10.3417V5.83332H10.8333V9.65832L13.925 12.75L12.7417 13.925Z"
      fill="#555555"
    />
  </SVG>
)

export default withIconStyles(IconClockFilled)
